<template>
  <div class="row mb-3" :class="errorClass">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="form-check form-check-inline w-25 mb-1" v-for="checkbox in checkboxes" v-bind:key="checkbox.id">
        <input v-on:change="checkboxClicked()" class="form-check-input" type="checkbox" v-model="checkbox.checked" :id="checkbox.id">
        <label class="form-check-label" :for="checkbox.id">
          {{checkbox.name}}
        </label>
      </div>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        Please tick the required number of checkboxes
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'checkboxLabels',
    'isRequired',
    'errorClass'
  ],
  data () {
    return {
    }
  },
  methods: {
    formatCheckBoxContent: function () {
      return '<ul>' + this.checkboxes.filter(x => { return x.checked }).map(x => {
        return '<li>' + x.name + '</li>'
      }).join('') + '</ul>'
    },
    checkboxClicked: function () {
      this.$emit('addedCheckBoxesContent', {
        label: this.label,
        content: this.formatCheckBoxContent(this.checkboxes),
        validated: this.checkboxes.filter(x => { return x.checked }).length > 0
      })
    }
  },
  computed: {
    checkboxes: function () {
      return this.checkboxLabels.split(',').map(x => {
        return {id: x.replace(/-/g, ' '), name: x, checked: false}
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FieldCheckBoxes.vue